import { Component, OnInit } from "@angular/core";
import { FormGroup, FormControl } from "@angular/forms";
import { UserService } from "src/app/services/user.service";
import { ToastrService } from "ngx-toastr";
import { Router } from "@angular/router"
import countryCodes from '../../../enums/country-codes'

@Component({
	selector: "app-esqueci-senha",
	templateUrl: "./esqueci-senha.component.html",
	styleUrls: ["./esqueci-senha.component.scss"],
})
export class EsqueciSenhaComponent implements OnInit {
	codigoEnviado = false;
	countryCodes = countryCodes;

	enviarCodigoForm = new FormGroup({
		email: new FormControl(),
		whatsApp: new FormControl(""),
		countryCode: new FormControl("55"),
	});

	senhaForm = new FormGroup({
		codigo: new FormControl(),
		novaSenha: new FormControl(),
		confirmacaoNovaSenha: new FormControl(),
	});

	constructor(
		private userService: UserService,
		private toastr: ToastrService,
		private router: Router
	) {}

	ngOnInit() {}

	enviar() {
		const values = this.enviarCodigoForm.getRawValue()
		this.userService
			.enviarCodigoRefazerSenha(values)
			.subscribe(
				(res) => {
					this.toastr.success("Código enviado para seu email com sucesso");
					this.codigoEnviado = true;
				},
				(err) => {
					this.toastr.error(
						"Dados não encontrados",
						"Usuário não encontrado"
					);
				}
			);
	}

	alterarSenha() {
		let values = this.senhaForm.getRawValue();

		if (values.novaSenha != values.confirmacaoNovaSenha) {
			this.toastr.warning("As senhas não conferem", "Dados incorretos");
			return;
		}

		values.email = this.enviarCodigoForm.getRawValue().email;

		this.userService.atualizarSenha(values).subscribe(
			(res) => {
				this.toastr.success("Dados alterados com sucesso", "Sucesso");
				this.senhaForm.disable();
				this.router.navigate(['/'])
			},
			(err) => {
				if (err.status == 401) {
					this.toastr.warning("Código incorreto", "Dados incorretos");
					this.senhaForm.disable();
				} else {
					this.toastr.error(
						"Erro ao se comunicar com o servidor",
						"Erro"
					);
				}
			}
		);
	}

	voltar () {
    window.history.back()
  }
}
